/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import contentHelper from 'helpers/contentHelper';
import { getIssuedManual } from 'views/App/Portal/Policy/IssuedManuals/_data_sources/useIssuedManual';
import { ManualPreface, ManualChapter, Manual } from 'views/App/Portal/Policy/_types/manuals/draft';
import { Policy, Section, SubSection } from 'views/App/Portal/Policy/_types/policy';

export default class manualHelper {
  static getNodeByContentUri = async (contentUri: string) => {
    if (_.isEmpty(contentUri)) {
      return null;
    }

    let result = {
      manual: null as Manual | null,
      chapter: null as ManualChapter | null,
      policy: null as Policy | null,
      preface: null as ManualPreface | null,
      section: null as Section | null,
      subSection: null as SubSection | null,
    };

    const parts = contentUri.split('://')[1].split('/');
    let manualId: string | null = null;
    let contentId: string | null = null;
    
    if (parts.length === 0) {
      return null;
    }
    
    if (parts[0] === 'manuals') {
      manualId = parts[1];
    }
    
    if (parts[2] === 'content') {
      contentId = parts[3];
    }
    
    if (_.isEmpty(manualId) || _.isEmpty(contentId)) {
      return null;
    }

    const manual = await getIssuedManual(manualId!);
    result.manual = manual;

    manual.prefaces.forEach((preface) => {
      if (preface.id === contentId) {
        result.preface = preface;
      }
    });

    manual.chapters.forEach((chapter) => {
      if (chapter.id === contentId) {
        result.chapter = chapter;
      } else {
        (chapter.policies || []).forEach((policy) => {
          if (policy.id === contentId) {
            result.chapter = chapter;
            result.policy = policy;
          } else {
            (policy.sections || []).forEach((section) => {
              if (section.id === contentId) {
                result.chapter = chapter;
                result.policy = policy;
                result.section = section;
              } else {
                (section.subSections || []).forEach((subSection) => {
                  if (subSection.id === contentId) {
                    result.chapter = chapter;
                    result.policy = policy;
                    result.section = section;
                    result.subSection = subSection;
                  }
                });
              }
            });
          }
        });
      }
    });
    
    return result;
  };

  static convertManual = (manual: any) => {
    const result = {
      id: manual.guid,
      organizationId: manual.organizationGuid,
      name: contentHelper.decodeHtmlEntities(manual.name.value),
      vertical: {
        key: manual.vertical.key,
        name: manual.vertical.value,
      },
      manualLevel: typeof manual.manualLevel === 'string' ? manual.manualLevel : undefined,
      manualType: {
        key: manual.manualType.key,
        name: manual.manualType.value,
      },
      jurisdiction: manual.jurisdiction,
      createdAt: manual.createDateTime,
      stagedAt: manual.stageDateTime,
      prefaces: manual.prefaces.map((preface: any) => ({
        id: preface.guid,
        title: preface.title.value,
        content: preface.content.value,
        headers: preface.headers || [],
      })),
      chapters: manual.chapters.map((chapter: any) => ({
        id: chapter.guid,
        key: chapter.heading,
        title: contentHelper.decodeHtmlEntities(chapter.title.value),
        policies: chapter.policies.map((policy: any) => ({
          id: policy.guid,
          key: policy.heading,
          title: contentHelper.decodeHtmlEntities(policy.title.value),
          effectiveDate: policy.effectiveDate,
          revisedDate: policy.revisedDate,
          issuingAuthority: policy.issuingAuthority,
          headers: policy.headers || [],
          sections: policy.sections.map((section: any) => ({
            id: section.guid,
            key: section.heading,
            title: contentHelper.decodeHtmlEntities(section.title.value),
            content: section.content.value,
            subSections: section.subSections.map((subSection: any) => ({
              id: subSection.guid,
              key: subSection.heading,
              title: contentHelper.decodeHtmlEntities(subSection.title.value),
              content: subSection.content.value,
            })),
          })),
        })),
      })),
      attachments: manual.attachments.map((a: any) => ({
        id: a.guid,
        title: a.title,
        mimeType: a.mimeType,
      })),
    };

    return result;
  };
}
